import React from 'react';
import { UserDto } from '../../models/user.dto';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import { isKeycloakIDP } from '../../utils/loginProvider';
import ChangePasswordForm from '../changePassword/change-password';

type ProfileInfoProps = {
   userData: UserDto;
};

const ProfileInfo = ({ userData }: ProfileInfoProps) => {
   const [translate] = useTranslation(['account', 'common']);

   return (
      <Table className='custom-table profile-card user-details-card'>
         <colgroup>
            <col className='profile-label-column' />
            <col className='profile-value-column' />
         </colgroup>
         <thead>
            <tr>
               <th colSpan={2}>
                  My user details
               </th>
            </tr>
         </thead>
         <tbody>
            <tr className='border-t'>
               <td>{translate('common:common.firstName')}</td>
               <td>{userData.firstName}</td>
            </tr>
            <tr className='border-t'>
               <td>{translate('common:common.lastName')}</td>
               <td>{userData.lastName}</td>
            </tr>
            <tr className='border-t'>
               <td>{translate('common:common.email')}</td>
               <td>{userData.email}</td>
            </tr>
            <tr className='border-t'>
               <td>{translate('common:profile.password')}</td>
               <td>{isKeycloakIDP && <ChangePasswordForm />}</td>
            </tr>
         </tbody>
      </Table>
   );
};

export default ProfileInfo;
